<template>
    <div class="row">
        <div :key="index" v-for="(field, index) in visibleFields" :class="field.column">
            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'text'">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <generic-tooltip :message="field.tooltip"  :position="field.tooltip_position">
                    <input-text slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-text>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="field.type === 'text' && !field.tooltip && !field.hide">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <input-text v-model="field.value" :field-data="field"></input-text>
            </div>
            
            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'file'">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <generic-tooltip :message="field.tooltip" :position="field.tooltip_position">
                    <input-file slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-file>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="field.type === 'file' && !field.tooltip && !field.hide">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <input-file v-model="field.value" :field-data="field"></input-file>
            </div>

            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'textarea'">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <generic-tooltip :message="field.tooltip" :position="field.tooltip_position">
                    <input-textarea slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-textarea>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="field.type === 'textarea' && !field.tooltip && !field.hide">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <input-textarea v-model="field.value" :field-data="field"></input-textarea>
            </div>
            
            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'checkbox'">
                <generic-tooltip :message="field.tooltip" :position="field.tooltip_position">
                    <input-checkbox slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-checkbox>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="field.type === 'checkbox' && !field.tooltip && !field.hide">
                <input-checkbox v-model="field.value" :field-data="field"></input-checkbox>
            </div>

            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'gated-text'">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <generic-tooltip :message="field.tooltip" :position="field.tooltip_position">
                    <input-gated-text slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-gated-text>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="field.type === 'gated-text'&& !field.hide && !field.tooltip && !field.hide">
                <label for="" v-if="field.label">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <input-gated-text v-model="field.value" :field-data="field"></input-gated-text>
            </div>

            <div class="w-100" v-if="field.tooltip && field.tooltip.length && !field.hide && (field.type === 'select' || field.type === 'multiselect')">
                <label for="">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <generic-tooltip :message="field.tooltip" :position="field.tooltip_position">
                    <input-selectbox slot="tooltip_sibling" v-model="field.value" :field-data="field"></input-selectbox>
                    <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                        <i class="fas fa-info-circle"></i>
                    </span>
                </generic-tooltip>
            </div>
            <div class="w-100" v-if="(field.type === 'select' || field.type === 'multiselect') && !field.tooltip && !field.hide">
                <label for="">
                    <span class="label-title">{{field.label}}</span>
                    <span v-if="field.required" class="required-field">*</span>
                </label>
                <input-selectbox v-model="field.value" :field-data="field"></input-selectbox>
            </div>

            <generic-tooltip :message="field.tooltip" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'json'" :position="field.tooltip_position">
                <input-json slot="tooltip_sibling" :config="cmOptionsJS" v-model="field.value" :field-data="field"></input-json>
                <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                    <i class="fas fa-info-circle"></i>
                </span>
            </generic-tooltip>
            <input-json v-if="field.type === 'json' && !field.tooltip && !field.hide" :config="cmOptionsJS" v-model="field.value" :field-data="field"></input-json>

            <generic-tooltip :message="field.tooltip" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'markdown'" :position="field.tooltip_position">
                <input-markdown slot="tooltip_sibling" :config="easyMDEConfigs" v-model="field.value" :field-data="field"></input-markdown>
                <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                    <i class="fas fa-info-circle"></i>
                </span>
            </generic-tooltip>
            <input-markdown v-if="field.type === 'markdown' && !field.tooltip && !field.hide" :config="easyMDEConfigs" v-model="field.value" :field-data="field"></input-markdown>

            <generic-tooltip :message="field.tooltip" v-if="field.tooltip && field.tooltip.length && !field.hide && field.type === 'wysiwyg'" :position="field.tooltip_position">
                <input-wysiwyg slot="tooltip_sibling" :field-data="field" v-model="field.value"></input-wysiwyg>
                <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                    <i class="fas fa-info-circle"></i>
                </span>
            </generic-tooltip>
            <input-wysiwyg v-if="field.type === 'wysiwyg' && !field.tooltip && !field.hide" :field-data="field" v-model="field.value"></input-wysiwyg>

            <generic-tooltip :message="field.tooltip" v-if="field.tooltip && field.tooltip.length && !field.hide && (field.type === 'date' || field.type === 'datetime') && renderDatetimePicker" :position="field.tooltip_position">
                <input-datetime-picker :form-index="index" slot="tooltip_sibling" :format="field.type === 'datetime' ? 'YYYY-MM-DD h:mm:ss A' : 'YYYY-MM-DD'" :field-data="field" v-model="field.value"></input-datetime-picker>
                <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                    <i class="fas fa-info-circle"></i>
                </span>
            </generic-tooltip>
            <input-datetime-picker :form-index="index" v-if="(field.type === 'date' || field.type === 'datetime') && !field.tooltip && !field.hide && renderDatetimePicker" :format="field.type === 'datetime' ? 'YYYY-MM-DD h:mm:ss A' : 'YYYY-MM-DD'" :field-data="field" v-model="field.value"></input-datetime-picker>
        </div>
    </div>
</template>

<script type="text/javascript">
    import InputText from '../form/form-text.vue';
    import InputFile from '../form/form-file.vue';
    import InputTextArea from '../form/form-textarea.vue';
    import InputMarkdown from '../form/form-markdown.vue';
    import InputCheckbox from '../form/form-checkbox.vue';
    import InputJson from '../form/form-json.vue';
    import FormWYSIWYG from '../form/form-wysiwyg';
    import FormDateTimePicker from '../form/form-datetime.vue';
    import InputGatedText from '../form/form-gated-text.vue';
    import InputSelectbox from '../form/form-selectbox.vue';
    import GenericTooltip from "../generic/generic-tooltip.vue";

    export default {
        name: 'form-loader',
        props: [
            'fields',
            'datePickerConfig',
            'codeMirrorConfig',
            'easyMdeConfig',
        ],
        components:{
            'input-selectbox': InputSelectbox,
            'input-text': InputText,
            'input-file': InputFile,
            'input-markdown': InputMarkdown,
            'input-json': InputJson,
            'input-textarea': InputTextArea,
            'input-checkbox': InputCheckbox,
            'input-wysiwyg': FormWYSIWYG,
            'input-datetime-picker' : FormDateTimePicker,
            'input-gated-text': InputGatedText,
            'generic-tooltip': GenericTooltip
        },
        data() {
            return {
                cmOptionsJS: null,
                easyMDEConfigs : null,
                renderDatetimePicker: true,
            }
        },
        mounted() {
            if (this.codeMirrorConfig != null) {
                this.cmOptionsJS = this.codeMirrorConfig
            }
            if (this.easyMdeConfig != null) {
                this.easyMDEConfigs = this.easyMdeConfig
            }
        },
        computed: {
            visibleFields : function() {
                if (this.fields) {
                    return this.fields.filter(field => !field.hide)
                }
            }
        },
        methods: {
            clearDatetimePicker: function() {
                //the only way to really reset the datetimepicker is by destroying and recreating the whole element
                this.forceRerender();
            },
            async forceRerender() {
                // Remove component from the DOM because of the v-if
                this.renderDatetimePicker = false;

                // Wait for the change to get flushed to the DOM
                await this.$nextTick();

                // Add the component back in
                this.renderDatetimePicker = true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
</style>
